module.exports = __webpack_public_path__ + "static/img/object-scanner_256.9784f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/object-scanner_256.png
// module id = gYHo
// module chunks = 0